export default __webpack_public_path__ + "static/genova-3-8cee8312890d1d1f99727c2d271f713b.jpg";